import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'

@Component({
  selector: 'app-logo-box',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div [class]="className">
      <a [routerLink]="link" class="logo-dark">
        <img
          src="assets/images/logo.png"
          [ngClass]="className == 'logo-box' ? 'logo-sm' : 'me-1'"
          [height]="logoHeight"
          alt="logo sm"
        />
      </a>

      <a [routerLink]="link" class="logo-light">
        <img
          src="assets/images/logo.png"
          [ngClass]="className == 'logo-box' ? 'logo-sm' : 'me-1'"
          [height]="logoHeight"
          alt="logo sm"
        />
      </a>
    </div>
  `,
})
export class LogoBoxComponent {
  @Input() className: string = ''
  @Input() height: string = ''
  @Input() logoHeight: string = ''
  /** Router target for the logo. Defaults to the app root. */
  @Input() link: string | any[] = '/'
}
